import Vue from 'vue'
import Vuex from 'vuex'
import getters from './getters'
import user from './modules/user'
import tougao from './modules/tougao'
import exam from './modules/exam'
import wechat from './modules/wechat'
import app from './modules/app'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        tougao,
        exam,
        wechat,
        app
    },
    getters
})

export default store
